import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(private storage: Storage) { }

  setValue(key: string, value: any) {
    this.storage.set(key, JSON.stringify(value));
  }

  async getValue(key: string): Promise<{ value: any }> {
    const val = await this.storage.get(key);
    return JSON.parse(val);
  }

  async removeValue(key: string) {
    await this.storage.remove(key);
  }

  async clearStorage() {
    await this.storage.clear();
  }
}
